// extracted by mini-css-extract-plugin
module.exports = {"root":"PatientConsentPreview_root__Ymdc_","description":"PatientConsentPreview_description__2m4Tn"};